<template>
    <div>
        <el-container direction="vertical">
            <div style="background-color: rgb(255, 255, 255); border: 1px solid #eee;">
                <div>
                    <el-form class="listQuery" label-width="80px" :inline="true" style="margin-top: 20px"
                        v-loading="formLoading">
                        <el-form-item label="机构">
                            <select-tree @input="input"></select-tree>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input v-model="listQuery.name"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="listQuery.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号">
                            <el-input v-model="listQuery.idcard"></el-input>
                        </el-form-item>
                        <el-form-item label="出生日期">
                            <el-date-picker v-model="birthdayData" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="建档时间">
                            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="档案状态">
                            <el-select v-model="listQuery.status" placeholder="请选择">
                                <el-option label="全部" :value="null"></el-option>
                                <el-option label="活动" value="活动"></el-option>
                                <el-option label="非活动" value="非活动"></el-option>
                                <el-option label="死亡" value="死亡"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="规范管理">
                            <el-select v-model="listQuery.isDiabetStdManage" placeholder="请选择">
                                <el-option label="全部" :value="null"></el-option>
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="疾病标签">
                            <el-select v-model="inLabelsSelected" multiple placeholder="请选择">
                                <el-option v-for="item in inLabelsOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="疾病等级">
                            <el-button type="primary" @click="addLabelDomain"
                                style="margin-left: 0px;">新增检索条件</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-form :model="labelDomains" ref="labelDomains" label-width="10px" :inline="true"
                                style="margin-left: 80px;">
                                <el-form-item v-for="(domain, index) in labelDomains" :key="domain.value"
                                    :prop="domains.value" style="margin-bottom: 10px;">
                                    <el-select v-model="domain.label" placeholder="请选择疾病标签">
                                        <el-option v-for="item in filterLabelsOptions" :key="item.value"
                                            :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <el-select v-model="domain.labelData" placeholder="请选择疾病等级"
                                        style="margin-left: 10px">
                                        <el-option v-for="item in filterLabelsLevelOptions" :key="item.value"
                                            :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <el-button style="margin-left: 10px"
                                        @click.prevent="removeLabelDomain(domain)">删除</el-button>
                                </el-form-item>
                            </el-form>
                        </el-form-item> -->

                        <el-form-item label="患者类型">
                            <el-checkbox-group v-model="listQuery.disease" style="width: 700px;">
                                <el-checkbox v-for="(item, index) in typeList" :key="index" :label="item"
                                    :value="item">{{ item }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="margin-left: 80px" @click="submitForm">查询</el-button>
                            <el-button type="primary" @click="addPatient">新建</el-button>
                            <el-button type="primary" @click="reportExportToExcel">导出</el-button>
                        </el-form-item>

                        <!-- <new-add-patient ref="addPatientRef" v-if="addPatientVisible"
                                @closeAdd="closeDialog"></new-add-patient> -->

                    </el-form>

                    <el-collapse style="margin-left: 70px">
                        <el-collapse-item>
                            <template slot="title">
                                <div style="font-size: 14px; font-weight: bolder; color: #606266">
                                    患者类型高级检索
                                </div>
                                <i class="el-icon-search" style="margin-top: 2px; margin-left: 5px"></i>
                            </template>
                            <el-form :model="domains" ref="domains" label-width="10px">
                                <el-form-item>
                                    <el-button type="primary" @click="addDomain">新增检索条件</el-button>
                                </el-form-item>
                                <el-form-item v-for="(domain, index) in domains" :key="domain.value"
                                    :prop="'domains.' + index + '.value'">
                                    <el-select v-model="domain.relation" :placeholder="index == 0 ? '-' : '请选择逻辑关系'"
                                        :disabled="index == 0 ? true : flase">
                                        <el-option v-for="item in relationList" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select v-model="domain.value" placeholder="请选择检索词" style="margin-left: 10px"
                                        @change="domainSelectChanged">
                                        <el-option v-for="item in typeList" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-button style="margin-left: 10px"
                                        @click.prevent="removeDomain(domain)">删除</el-button>
                                </el-form-item>
                            </el-form>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <el-table v-loading="listLoading" :data="list" border fit highlight-current-row
                    style="width: 100%; margin-left: 0px;">
                    <el-table-column align="center" label="姓名" min-width="70">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="性别" min-width="50">
                        <template slot-scope="scope">
                            <span>{{ getGender(scope.row.gender) }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="出生年月" min-width="100">
                        <template slot-scope="scope">
                            <span>{{ scope.row.birthday }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="年龄" min-width="60">
                        <template slot-scope="scope">
                            <span>{{ getAge(scope.row.birthday) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="电话号码" min-width="100">
                        <template slot-scope="scope">
                            <span>{{ scope.row.phone }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column width="170px" align="center" label="身份证号" min-width="180">
                        <template slot-scope="scope">
                            <span>{{ scope.row.idcard }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="所属机构" min-width="120">
                        <template slot-scope="scope">
                            <span>{{ scope.row.managerHospital }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="就诊标签" min-width="120">
                        <template slot-scope="scope">
                            <span>{{ getTag(scope.row) }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="标签" min-width="120">
                        <template slot-scope="scope">
                            <span :class="scope.row.label0">规</span>
                            <span :class="scope.row.label1">压</span>
                            <span :class="scope.row.label2">脂</span>
                            <span :class="scope.row.label3">糖</span>
                            <span :class="scope.row.label4">糖易</span>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" align="center" label="操作" width="220">
                        <template slot-scope="scope">
                            <el-button style="margin-left: 0px; align-self: center" type="text"
                                @click="patientsDetail(scope.row)">
                                健康档案
                            </el-button>

                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="patientsEdit(scope.row)">
                                编辑
                            </el-button>

                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="setHouseholder(scope.row)">
                                设为户主
                            </el-button>

                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="delPatient(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize" @pagination="turnToPage" />

                <edit-patient v-if="editPatientVisible" ref="editPatientRef"></edit-patient>

                <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>

                <patient-record v-if="patientRecordVisible" ref="PatientRecordRef"></patient-record>

                <add-patient v-if="addPatientVisible" ref="addPatientRef" @closeAdd="closeDialog"></add-patient>
            </div>
        </el-container>
    </div>
</template>
<script>
import {
    getSearchList,
    getSearchListByLabel,
    turnToPageList,
    turnToPageListByLabel,
    delPatientList,
    getlistEhrDepts,
    getByIdPatientDetail,
    addContactList,
    reportToExcel,
    getSolrSearchList,
    turnToSolrPageList,
    getSysDicList
} from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import addPatient from "@/views/patient/addPatient";
import editPatient from "@/views/patient/editPatient";
import patientDetail from "@/views/patient/patientDetail";
import patientRecord from "@/views/patient/patientRecord";
import SelectTree from "@/components/selectTree";
import { Loading } from "element-ui";
import moment from "moment";

export default {
    components: {
        Pagination,
        patientDetail,
        patientRecord,
        SelectTree,
        addPatient,
        editPatient,
    },
    data() {
        return {
            data: [],
            list: null,
            total: 0,
            listLoading: false,
            formLoading: false,
            valueData: null,
            birthdayData: null,
            loadingOptions: {
                text: "正在导出...",
                background: "rgba(0, 0, 0, 0.6)",
            },
            listQuery: {
                managerHospitals: [],
                name: null,
                phone: null,
                idcard: null,
                doctorResponse: null,
                birthdayStart: null,
                birthdayEnd: null,
                createTimeStart: null,
                createTimeEnd: null,
                hyperBPRisk: null,
                hyperDiabetesRisk: null,
                hyperTCRisk: null,
                disease: [],
                pageNum: 0,
                pageSize: 10,
                easyillDiabetes: null,
                status: null,
                isDiabetStdManage: null,
                inLabels: [],
                filterLabels: []
            },
            inLabelsSelected:[],
            relationList: ["与", "或", "非"],
            typeList: [
                "高血压",
                "糖尿病",
                "高血脂",
                "慢阻肺",
                "冠心病",
                "脑卒中",
                "肾病综合征",
                "眼底病变",
                "周围神经病变",
                "周围血管病变",
            ],
            preTypeList: ["高血压", "糖尿病", "高血脂", "慢阻肺"],
            postTypeList: [
                "冠心病",
                "脑卒中",
                "肾病综合征",
                "眼底病变",
                "周围神经病变",
                "周围血管病变",
            ],
            managerHospitalList: [],
            patientDetailVisible: false,
            patientRecordVisible: false,
            addPatientVisible: false,
            editPatientVisible: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            domains: [
                {
                    relation: "",
                    value: "",
                },
            ],
            labelDomains: [
                {
                    label: "",
                    labelData: "",
                },
            ],
            inLabelsOptions: [
                {
                    value: "easy_hyper",
                    label: "高血压易患",
                },
                {
                    value: "easy_diabet",
                    label: "糖尿病易患",
                },
                {
                    value: "hyper",
                    label: "高血压确诊",
                },
                {
                    value: "diabet",
                    label: "糖尿病确诊",
                },
                {
                    value: "copd",
                    label: "慢阻肺确诊",
                },
                {
                    value: "lungcancer",
                    label: "肺癌确诊",
                },
                {
                    value: "hyperuricemia",
                    label: "高尿酸血症确诊",
                },
                {
                    value: "easy_hyperuricemia",
                    label: "尿酸高危",
                },
                {
                    value: "overweight",
                    label: "高体重",
                },
                {
                    value: "easy_lungcancer",
                    label: "肺癌高危",
                }
            ],
            filterLabelsOptions: [
                {
                    value: "diabet_level",
                    label: "血糖检测红黄绿等级",
                },
                {
                    value: "hypertension_level",
                    label: "血压检测红黄绿等级",
                }
            ],
            filterLabelsLevelOptions: [
                {
                    value: "1",
                    label: "绿",
                },
                {
                    value: "2",
                    label: "黄",
                },
                {
                    value: "3",
                    label: "红",
                }
            ],
            exportBody: {
                url: "/business/ehr/search",
                headers: [
                    "姓名",
                    "性别",
                    "出生年月",
                    "电话号码",
                    "身份证号",
                    "所属机构",
                    "就诊类型",
                    "就诊次数"
                ],
                keys: [
                    "name",
                    "gender",
                    "birthday",
                    "phone",
                    "idcard",
                    "managerHospital",
                    "patientType",
                    "visitTimes"
                ],
                body: null,
            },
            sexOptions: []
        };
    },
    created() {
        var typeData = "性别";
        this.getSystemDictList(typeData);
        this.submitForm();
    },
    methods: {
        getSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sexOptions = records;
            }).catch(err => {
                console.log(err);
            })
        },
        getGender(gender) {
            var option = this.sexOptions.filter(v => v.value == gender)[0];
            return option.name;
        },
        //就诊标签
        getTag(item) {
            var type = "";
            var num = "";
            if (item.patientType != null) {
                if (item.patientType == "1") {
                    type = "门诊";
                } else if (item.patientType == "2") {
                    type = "住院";
                }
            }

            if (item.visitTimes != null) {
                num = item.visitTimes;
            }

            return type + num;
        },
        //查询结果导出
        reportExportToExcel() {
            console.log(
                "查询结果导出",
                `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
            );

            let loadingInstance = Loading.service(this.loadingOptions);

            this.exportBody.url =
                "/business/ehr/search?page=" +
                this.listQuery.pageNum +
                "&pageSize=" +
                this.listQuery.pageSize;

            this.exportBody.body = this.listQuery;
            console.log("导出表格请求body：", this.exportBody);

            reportToExcel(this.exportBody)
                .then((res) => {
                    console.log("查询表格导出====", res);

                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    let blob = new Blob([res], { type: "application/force-download" });
                    console.log(blob);
                    let fileReader = new FileReader();
                    fileReader.readAsDataURL(blob);
                    fileReader.onload = (e) => {
                        let a = document.createElement("a");
                        a.download = `个人档案${moment(new Date()).format(
                            "YYYYMMDDHHmm"
                        )}.xlsx`;
                        a.href = e.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };
                })
                .catch((error) => {
                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    console.log(error);

                    this.$message({
                        message: "导出失败",
                        type: "error",
                    });
                });
        },
        removeLabelDomain(item) {
            var index = this.labelDomains.indexOf(item);
            if (index !== -1) {
                this.labelDomains.splice(index, 1);
            }
        },
        addLabelDomain() {
            this.labelDomains.push({
                label: "",
                labelData: "",
            });
        },
        removeDomain(item) {
            var index = this.domains.indexOf(item);
            if (index !== -1) {
                this.domains.splice(index, 1);
            }
        },
        addDomain() {
            this.domains.push({
                value: "",
                relation: "",
            });
        },
        domainSelectChanged(selItem) {
            console.log("当前选项", selItem);
            var index = this.preTypeList.indexOf(selItem);
            if (index !== -1) {
                for (let i = 0; i < this.domains.length; i++) {
                    var item = this.domains[i];
                    var value = item.value;
                    if (this.postTypeList.indexOf(value) !== -1) {
                        this.$message.error("请确认检索词");
                        var curItem = this.domains[this.domains.length - 1];
                        curItem.value = "";
                        return;
                    }
                }
            }
        },
        // 获取机构数组
        input(value) {
            console.log("机构数组：",value);
            this.listQuery.managerHospitals = value;
        },
        setLabel0(value) {
            if (value.isDiabetStdManage == "是") {
                return "labelBlue";
            } else {
                return "labelNone";
            }
        },
        setLabel1(value) {
            if (
                value.isBloodpressure == "否" ||
                value.isBloodpressure == null ||
                value.isBloodpressure == ""
            ) {
                this.showLabel1 = false;
                return "labelNone";
            } else {
                this.showLabel1 = true;
                if (
                    value.hyerBpRisk == null ||
                    value.hyerBpRisk == "0" ||
                    value.hyerBpRisk == ""
                ) {
                    return "labelGray";
                } else if (value.hyerBpRisk == "1") {
                    return "labelGreen";
                } else if (value.hyerBpRisk == "2") {
                    return "labelOrange";
                } else if (value.hyerBpRisk == "3") {
                    return "labelRed";
                }
            }
        },
        setLabel2(value) {
            if (
                value.isAscvd == "否" ||
                value.isAscvd == null ||
                value.isAscvd == ""
            ) {
                this.showLabel2 = false;
                return "labelNone";
            } else {
                this.showLabel2 = true;
                if (
                    value.hyperTcRisk == null ||
                    value.hyperTcRisk == "0" ||
                    value.hyperTcRisk == ""
                ) {
                    return "labelGray";
                } else if (value.hyperTcRisk == "1") {
                    return "labelGreen";
                } else if (value.hyperTcRisk == "2") {
                    return "labelOrange";
                } else if (value.hyperTcRisk == "3") {
                    return "labelRed";
                }
            }
        },
        setLabel3(value) {
            if (
                value.isDiabet == "否" ||
                value.isDiabet == null ||
                value.isDiabet == ""
            ) {
                this.showLabel3 = false;
                return "labelNone";
            } else {
                this.showLabel3 = true;
                if (
                    value.hyperDiabetesRisk == null ||
                    value.hyperDiabetesRisk == "0" ||
                    value.hyperDiabetesRisk == ""
                ) {
                    return "labelGray";
                } else if (value.hyperDiabetesRisk == "1") {
                    return "labelGreen";
                } else if (value.hyperDiabetesRisk == "2") {
                    return "labelOrange";
                } else if (value.hyperDiabetesRisk == "3") {
                    return "labelRed";
                }
            }
        },
        setLabel4(value) {
            if (value.easyillDiabetes) {
                return "labelPurple";
            } else {
                return "labelNone";
            }
        },
        // 关闭新建弹窗
        closeDialog(value) {
            console.log("关闭新建弹窗", value);
            this.addPatientVisible = value;
        },
        // 新建病人档案
        addPatient() {
            this.addPatientVisible = true;
            var value = this.addPatientVisible;
            this.$nextTick(() => {
                this.$refs.addPatientRef.init(value);
            });
        },
        // 将该患者设置为户主
        setHouseholder(value) {
            if (value.isHeadFamily == "1") {
                this.$message({
                    message:
                        "已经有以此人为户主的家庭档案信息存在！请转往家庭档案处查看。",
                    type: "warning",
                });
                return;
            }
            this.$confirm(
                "此操作将在家庭档案中以此人为户主建立家庭档案信息, 是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    var contactParams = {
                        idcard: value.idcard,
                        name: value.name,
                        phone: value.phone,
                        relationCode: "0",
                        relationName: "本人或户主",
                        householderIdcard: value.idcard
                    };

                    addContactList(contactParams)
                        .then((res) => {
                            if (res.msg == "success") {
                                this.$message({
                                    message: "设置成功！",
                                    type: "success",
                                });
                            }
                            this.submitForm();
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消设置",
                    });
                });
        },
        // 删除病人档案
        delPatient(value) {
            this.$confirm("此操作将删除该档案信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const patientData = {
                        id: value.id,
                    };
                    this.listLoading = true;
                    delPatientList(patientData).then((res) => {
                        this.listLoading = false;
                        if (res.msg == "success") {
                            this.$message({
                                message: "删除成功！",
                                type: "success",
                            });
                            // 更新视图列表
                            this.turnToPage();
                        } else {
                            this.$message({
                                message: "删除失败！",
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 查询健康列表
        submitForm() {
            // console.log("检索条件：", this.domains);

            this.listLoading = true;
            if (this.valueData != null) {
                this.listQuery.createTimeStart = this.getParseDate(
                    this.valueData[0],
                    1
                );
                this.listQuery.createTimeEnd = this.getParseDate(this.valueData[1], 2);
            } else {
                this.listQuery.createTimeStart = null;
                this.listQuery.createTimeEnd = null;
            }
            if (this.birthdayData != null) {
                this.listQuery.birthdayStart = this.getParseDate(
                    this.birthdayData[0],
                    1
                );
                this.listQuery.birthdayEnd = this.getParseDate(this.birthdayData[1], 2);
            } else {
                this.listQuery.birthdayStart = null;
                this.listQuery.birthdayEnd = null;
            }

            // if (this.inLabelsSelected.length > 0) {
            //     var labelsDataArr = [];
            //     for (let i = 0; i < this.inLabelsSelected.length; i++) {
            //         const labelItem = this.inLabelsSelected[i];
            //         var labelParam = {
            //             label: labelItem
            //         };
            //         labelsDataArr.push(labelParam);
            //     }
            //     this.listQuery.inLabels = labelsDataArr;
            // }

            // this.listQuery.filterLabels = this.labelDomains;

            getSearchList(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list = res.data.records;
                    this.total = res.data.total;
                    this.list.forEach((item, index) => {
                        this.list[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 导航跳转查询列表页
        turnToPage() {
            this.listLoading = true;
            if (this.valueData != null) {
                this.listQuery.createTimeStart = this.getParseDate(
                    this.valueData[0],
                    1
                );
                this.listQuery.createTimeEnd = this.getParseDate(this.valueData[1], 2);
            } else {
                this.listQuery.createTimeStart = null;
                this.listQuery.createTimeEnd = null;
            }
            if (this.birthdayData != null) {
                this.listQuery.birthdayStart = this.getParseDate(
                    this.birthdayData[0],
                    1
                );
                this.listQuery.birthdayEnd = this.getParseDate(this.birthdayData[1], 2);
            } else {
                this.listQuery.birthdayStart = null;
                this.listQuery.birthdayEnd = null;
            }

            turnToPageList(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list = res.data.records;
                    this.total = res.data.total;
                    this.list.forEach((item, index) => {
                        this.list[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 跳转至相应病人档案详情页
        patientsDetail(row) {
            this.patientDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["PatientDetailRef"].init(row);
            });

            // this.$router.push({path: '/patientDetail',query: row})
        },
        // 编辑个人档案
        patientsEdit(row) {
            let params = {
                id: row.id,
            };
            getByIdPatientDetail(params)
                .then((res) => {
                    if (res.msg == "success") {
                        // console.log("========", res, row);
                        var data = res.data;
                        this.editPatientVisible = true;
                        this.$nextTick(() => {
                            this.$refs["editPatientRef"].init(data);
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // 日期格式转化
        getParseDate(time, type) {
            if (type == 1) {
                var newTime = new Date(time);
            } else if (type == 2) {
                var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
            }
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return (
                year +
                "-" +
                (month < 10 ? "0" + month : month) +
                "-" +
                (date < 10 ? "0" + date : date)
            );
        },
        // 身份证号加密
        formatIDcard(card) {
            if (card == null) return "";

            var str = card;
            str = str.toString().replace(/^(.{3})(?:\w+)(.{4})$/, "$1***********$2");
            return str;
        },
        // 手机号加密
        formatPhone(card) {
            if (card == null) return "";

            var str = card;
            if (str.length == 11) {
                str = str.toString().replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
                return str;
            } else if (str.length == 8) {
                str =
                    str.toString().substring(0, 2) + "****" + str.substr(str.length - 2);
                return str;
            } else {
                return str;
            }
        },
        // 计算当前年龄
        getAge(birthday) {
            if (birthday == null) return "";

            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        },
    },
};
</script>
<style lang="scss" scoped>
.listQuery {
    display: flex;
    flex-wrap: wrap;
    margin-top: 22px;
}

// .labelRed {
//     border-radius: 50%;
//     color: white;
//     background: red;
//     padding: 3px;
// }

.labelRed {
    height: 24px;
	width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
}


.labelBlue {
    border-radius: 50%;
    color: white;
    background: blue;
    padding: 3px;
}

.labelOrange {
    border-radius: 50%;
    color: white;
    background: orange;
    padding: 3px;
}

.labelGreen {
    border-radius: 50%;
    color: white;
    background: green;
    padding: 3px;
}

.labelGray {
    border-radius: 50%;
    color: white;
    background: gray;
    padding: 3px;
}

.labelPurple {
    border: 1px solid purple;
    background: purple;
    color: #fff;
    padding: 2px;
    border-radius: 50%;
}

.labelNone {
    display: none;
}

::v-deep .el-form {

    // .el-input__inner {
    //   width: 250px;
    // }
    .el-input {
        width: 250px;
    }

    .el-date-editor {
        width: 250px;
    }

    .el-form-item__label {
        width: 140px !important;
    }

    .el-form-item:last-child .el-form-item__content {
        display: flex;
    }
}
</style>